import { useState, type ReactElement } from 'react';
import { NewPlanForm } from './NewPlanForm';
import { PlanPreview } from './PlanPreview';
import type { CoachPlanRequest, CoachPlanResponse } from '@/lib/coach';

/**
 * Página `/coach/nuevo-plan`.
 *
 * Mantiene en estado local el último resultado y la petición que lo produjo,
 * para que el preview pueda "Aceptar" reenviando la MISMA petición con
 * `preview: false` sin que el usuario tenga que rellenar el form de nuevo.
 *
 * Decisión: cuando hay resultado, ocultamos el form (en lugar de mostrar ambos
 * apilados) para evitar que el usuario lance otra petición accidentalmente
 * mientras revisa. Botón "Generar otro plan" vuelve al form.
 */
export function CoachPage(): ReactElement {
  const [state, setState] = useState<{
    result: CoachPlanResponse;
    request: CoachPlanRequest;
  } | null>(null);

  if (state) {
    return (
      <div className="space-y-6">
        <PlanPreview
          result={state.result}
          request={state.request}
          onAccepted={(next) =>
            setState((prev) => (prev ? { request: prev.request, result: next } : null))
          }
          onDiscard={() => setState(null)}
        />
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => setState(null)}
            className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2"
          >
            Generar otro plan
          </button>
        </div>
      </div>
    );
  }

  return (
    <NewPlanForm
      onResult={(result, request) => setState({ result, request })}
    />
  );
}
